document.addEventListener("DOMContentLoaded", () => {

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;    

    const carousels = document.querySelectorAll(".text-carousel-block .swiper");
    
    carousels.forEach((carousel) => {
        let blockId = carousel.closest('.text-carousel-block').id; 
        let scrollbar = document.querySelector(`#${blockId} .swiper-scrollbar`);
        let cover = document.querySelector(`#${blockId} .cover`);
        let slideImgs = document.querySelectorAll(`#${blockId} .swiper-slide img`);

        if (scrollbar) {
            new Swiper(carousel, {
                slidesPerView: "auto",
                setWrapperSize: true,
                navigation: false,
                scrollbar: {
                    el: scrollbar,
                    draggable: true,
                },        
            });
        }
        
        const carouselAnim = gsap.timeline({
            scrollTrigger: {
                trigger: carousel,
                start: "top bottom",
                end: "bottom 50%",
                scrub: true,
            },
        });

        if (isDesktop) {
            gsap.set(cover, { opacity: 0, y: "50px" });            
    
            carouselAnim.to(
                cover,
                {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "expo.inOut",
                },
                "<"
            );
        }

        slideImgs.forEach((img) => {
            carouselAnim.to(
                img,
                {
                    scale: 1.1,
                    duration: 1,
                    ease: "expo.inOut",
                },
                "<"
            );
        });

        

    });

});
